import React, { Component } from 'react';
import SubSection from '../../libs/react-components-admin/section/sub-section';

class FormValidation extends Component {

  constructor(props) {
    super(props);
    this.state = {
      value: {},
      propsLoaded: false
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    let value = prevState.value;
    let propsLoaded = prevState.propsLoaded;
    if (nextProps.value && !propsLoaded) {
      value = nextProps.value;
      propsLoaded = true;
    }
    return { value, propsLoaded };
  }

  render() {
    return <SubSection title="Validation" className="my-3">
      <div className="mb-3">
        <label htmlFor="errorMessageText" className="form-label">Error message</label>
        <input type="text"
               id="errorMessageText" name="errorMessageText"
               className="form-control"
               value={(this.state.value.errorMessage || {}).text || ''}
               onChange={e => {
                 const text = e.target.value;
                 this.setState((prevState, props) => {
                   const value = {
                     ...prevState.value,
                     errorMessage: { ...prevState.errorMessage, text }
                   };
                   props.onChange(value);
                   return { value };
                 })
               }}
               placeholder="e.g. Some fields are invalid" />
        <div className="form-text">Message displayed when some fields are invalid</div>
      </div>
    </SubSection>
  }

}

export default FormValidation;
